import { useNavigate, useSearchParams } from "react-router-dom";
import {
  CustomersListPage as CustomersListPageView,
  type CustomersListFilters,
} from "@/components/CustomersListPage";

export function CustomersListPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultFilters: CustomersListFilters = {
    name: searchParams.get("name") ?? undefined,
    email: searchParams.get("email") ?? undefined,
  };

  function handleFiltersChange(filters: CustomersListFilters) {
    const next = new URLSearchParams();
    if (filters.name) next.set("name", filters.name);
    if (filters.email) next.set("email", filters.email);
    setSearchParams(next, { replace: true });
  }

  return (
    <CustomersListPageView
      onCustomerClick={(id) => navigate(`/customers/${id}`)}
      defaultFilters={defaultFilters}
      onFiltersChange={handleFiltersChange}
    />
  );
}
